import { IVenueCategory } from 'src/api/getVenueCategories';

/**
 * Recursively collects all descendant category IDs for a given category.
 *
 * @param categoryId - The ID of the category to find descendants for (null returns empty Set)
 * @param categories - Array of all categories to search through
 * @param descendantIds - Set to accumulate descendant IDs (used internally for recursion)
 * @returns Set containing all descendant category IDs
 */
export const getDescendantIds = (
  categoryId: string | null,
  categories: IVenueCategory[],
  descendantIds: Set<string> = new Set(),
): Set<string> => {
  if (categoryId === null) return descendantIds;

  const children = categories.filter((cat) => cat.parent_category_id === categoryId);

  children.forEach((child) => {
    if (child.category_id !== null) {
      descendantIds.add(child.category_id);
      getDescendantIds(child.category_id, categories, descendantIds);
    }
  });

  return descendantIds;
};
